// import * as loadImage from 'blueimp-load-image';

const ImageReaderUtil = {
  readAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = reject;

      reader.readAsDataURL(file);
    });
  },
  fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
      try {
        loadImage(file, (img) => {
          resolve(
            img.toDataURL(file.type),
          );
        }, {
          canvas: true, orientation: true,
        });
      } catch (e) {
        reject(e);
      }
    });
  },
};

export default ImageReaderUtil;
